import { BasicTooltip, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Box, Container, Typography, Grid, IconButton } from '@mui/material';
import React from 'react';
import useStyles from '../styles';
const basicTooltipExample = "\nimport { BasicTooltip } from '@livable/saas-react-components';\n\n<BasicTooltip title={tooltipText} placement=\"top\">\n  <IconButton>\n    <Icon type=\"plus\" />\n  </IconButton>\n</BasicTooltip>\n";
const greyInfoTooltipExample = "\nimport { ExpandedTooltip } from '@livable/saas-react-components';\n\n<ExpandedTooltip type=\"grey\" title={tooltipText} placement=\"top\">\n  <IconButton>\n    <Icon type=\"question\" />\n  </IconButton>\n</ExpandedTooltip>\n";
const tooltipExample = key => "\nimport { ExpandedTooltip } from '@livable/saas-react-components';\n\n<ExpandedTooltip type=\"".concat(key, "\" title={TooltipCrossIcon} placement=\"top\">\n  <IconButton>\n    <Icon type=\"success\" />\n  </IconButton>\n</ExpandedTooltip>\n");
const utilitiesTooltipExample = key => "\n  import { ExpandedTooltip } from '@livable/saas-react-components';\n  \n  <ExpandedTooltip type=\"utilities-".concat(key, "\" title={UtilitiesTooltipBody} placement=\"top\">\n    <IconButton>\n      <Icon type=\"question\" />\n    </IconButton>\n  </ExpandedTooltip>\n");
export default function LvTooltips() {
  const classes = useStyles();
  const tooltipText = 'This information may be used for payee details. If there are multiple owners, please list the one we should make the reimbursement to, if applicable.';
  const getTooltipIcon = (Component, text) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, null), /*#__PURE__*/React.createElement("span", null, text));
  const ErrorIcon = () => /*#__PURE__*/React.createElement(Icon, {
    type: "error"
  });
  const InfoIcon = () => /*#__PURE__*/React.createElement(Icon, {
    type: "info"
  });
  const SuccessIcon = () => /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  });
  const WarningIcon = () => /*#__PURE__*/React.createElement(Icon, {
    type: "warning"
  });
  const obj = {
    Default: getTooltipIcon(ErrorIcon, 'Invite team members'),
    Info: getTooltipIcon(InfoIcon, 'Invite team members'),
    Success: getTooltipIcon(SuccessIcon, 'Invite team members'),
    'Success-bold': getTooltipIcon(SuccessIcon, 'Invite team members'),
    Warning: getTooltipIcon(WarningIcon, 'Invite team members'),
    Error: getTooltipIcon(WarningIcon, 'Invite team members')
  };
  const utilitiesObj = {
    default: {
      name: 'Utilities Default Tooltip',
      type: 'utilities-default'
    },
    error: {
      name: 'Utilities Error Tooltip',
      type: 'utilities-error'
    },
    // info: {
    //   name: 'Utilities Info Tooltip',
    //   type: 'utilities-info',
    // },
    success: {
      name: 'Utilities Success Tooltip',
      type: 'utilities-success'
    },
    'success-bold': {
      name: 'Utilities Success-bold Tooltip',
      type: 'utilities-success-bold'
    },
    warning: {
      name: 'Utilities Warning Tooltip',
      type: 'utilities-warning'
    }
  };
  const utilities = Object.keys(utilitiesObj).map(key => key);
  const basics = Object.keys(obj).map(key => key);
  const UtilitiesTooltipBody = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-header"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Resident does not pay for:")), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.billingOpt
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "water"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Water")), /*#__PURE__*/React.createElement("div", {
    className: classes.billingOpt
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "electricity"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Electricity"))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Tooltips"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Tooltips"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Basic Tooltip"), /*#__PURE__*/React.createElement(BasicTooltip, {
    title: "Invite team members to collaborate",
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, basicTooltipExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Grey Tooltip"), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: tooltipText,
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, greyInfoTooltipExample)), basics.map(basic => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, basic, " Tooltip"), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: "Invite team members to collaborate",
    type: basic.toLowerCase()
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  }))), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: obj[basic],
    type: basic.toLowerCase()
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, tooltipExample(basic.toLowerCase())))), utilities.map(utility => /*#__PURE__*/React.createElement(Grid, {
    key: utility,
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, utilitiesObj[utility].name), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: UtilitiesTooltipBody,
    type: utilitiesObj[utility].type
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, utilitiesTooltipExample(utility))))))));
}